<script setup>
import AppButton from '#/general/AppButton.vue'
</script>

<template lang="pug">
.us--goals
  .us--goals-title Unsere Ziele bis 2030 sind dabei sehr ehrgeizig.
  .us--goals-stats 1 Mrd.&nbsp;&nbsp;|&nbsp;&nbsp;5 Mio.&nbsp;&nbsp;|  22 Tsd.
  .us--goals-description
    span Bis 2030 wollen wir schweizweit 1 Mrd. m
    sup 2 &#32;
    span an Verdichtungspotenzial aufdecken, 5 Mio. EigentümerInnen über das Potenzial ihrer Liegenschaft aufklären und dabei Wohn- und Lebensraum für 22'000 Menschen schaffen. Das gelingt, wenn wir es schaffen, eine eigentliche Bewegung zu starten – und möglichst viele EigentümerInnen zu Raumpionieren zu machen.
  app-button.us--goals-cta(label="Jetzt Potenzial prüfen" to="/b2c/analyzer" padding="12px 46px" )
  .us--goals-second-title
    | Wir machen das –
    br
    | und zwar richtig gut.
  .us--goals-second-description
    | Wir sind ein starkes Team und gewinnen oder verlieren gemeinsam – das Lachen vergeht uns dabei aber nie wirklich. Wir machen anstatt zu zaudern, verschieben oder zu vertagen. Unser Anspruch ist es, für Ihre Herausforderungen nachhaltige Lösungen zu finden und zu halten, was wir versprechen.
    br
    br
    | Dabei machen wir das, was wirklich ansteht. Denn wir wissen ganz genau, worüber wir sprechen. Die entscheidenden Details zu kennen, im Team ein gemeinsames Verständnis zu schaffen und dann zu priorisieren – das alles zeichnet uns aus. Eigentlich sind es ja zwei Fragen, die uns umtreiben: Sind wir heute besser als gestern? Und werden wir morgen noch etwas besser sein als heute?
</template>

<style lang="sass">
.us--goals
  display: flex
  flex-direction: column
  align-items: center
  .us--goals-title
    font-weight: 500
    line-height: 150%
    text-align: center
    color: #22223C
    @media screen and (min-width: 1024px)
      margin-top: 145px
      font-size: 34px
    @media screen and (max-width: 1024px)
      margin-top: 70px
      font-size: 20px
  .us--goals-stats
    font-weight: 600
    line-height: 150%
    text-align: center
    color: #22223C
    @media screen and (min-width: 1024px)
      font-size: 80px
      margin-top: 82px
    @media screen and (max-width: 1024px)
      font-size: 28px
      margin-top: 40px
  .us--goals-description
    font-weight: 400
    line-height: 150%
    text-align: center
    color: #22223C
    max-width: 850px
    @media screen and (min-width: 1024px)
      margin-top: 62px
      font-size: 20px
    @media screen and (max-width: 1024px)
      margin-top: 30px
      font-size: 16px
  .us--goals-cta
    margin-top: 35px
  .us--goals-second-title
    font-weight: 500
    line-height: 130%
    text-align: center
    color: #22223C
    @media screen and (min-width: 1024px)
      margin-top: 135px
      font-size: 55px
    @media screen and (max-width: 1024px)
      margin-top: 60px
      font-size: 30px
  .us--goals-second-description
    font-weight: 400
    line-height: 150%
    text-align: center
    color: #22223C
    max-width: 850px
    @media screen and (min-width: 1024px)
      margin-top: 70px
      font-size: 20px
    @media screen and (max-width: 1024px)
      margin-top: 34px
      font-size: 16px
</style>
